<template>
    <div>
        <CRow>
            <CCol sm="12">
                <CCard>
                    <CCardHeader>
                        <strong>ویرایش شماره در لیست سیاه اختصاصی</strong>
                    </CCardHeader>
                    <CCardBody>
                        <CForm @keyup.enter="validator();submit()">
                            <CRow>
                                <CCol sm="3">
                                    <label>کاربر</label>
                                    <model-select :options="users" v-model="form.user_id.val" placeholder="انتخاب کنید">
                                    </model-select>
                                    <small class="form-text text-muted w-100">{{form.user_id.inv}}</small>
                                </CCol>
                                <CCol sm="3">
                                    <label>از شماره</label>
                                    <model-select :options="numbers" v-model="form.form_number.val" placeholder="انتخاب کنید">
                                    </model-select>
                                    <small class="form-text text-muted w-100">{{form.form_number.inv}}</small>
                                </CCol>
                                <CCol sm="3">
                                    <CInput v-model="form.to_number.val" :description="form.to_number.inv" dir="ltr" label="به شماره" />
                                </CCol>
                                <CCol sm="3">
                                    <CSelect
                                        v-model="form.full_deny.val"
                                        :description="form.full_deny.inv"
                                        label="وضعیت"
                                        :options="[
                                            {value: 'true', label:'فعال'},
                                            {value: 'false', label:'غیرفعال'},
                                        ]"
                                        placeholder="انتخاب کنید"
                                        @change="form.full_deny.val=$event.target.value"
                                    />
                                </CCol>
                            </CRow>
                        </CForm>
                        <br>
                        <div class="form-group form-actions">
                            <CButton @click="validator();submit()" color="primary"> ویرایش</CButton>
                        </div>    
                    </CCardBody>
                </CCard>
            </CCol>
        </CRow>
    </div>
</template>

<script>
import { ModelSelect } from 'vue-search-select'
import validator from '../mixins'
export default {
    mixins: { validator },
    components: { ModelSelect },
    data() {
        return {
            form: {
                user_id: {val: '', inv: '', v: { req: true, max: 8 }},
                from_number: {val: '', inv: '', v: { req: true, max: 64 }},
                to_number: {val: '', inv: '', v: { req: true, max: 64, spec: 'mobile_number'}},
				full_deny: {val: '', inv: '', v: { req: true, max: 8 }},
			},
            disable: false,
            users: [],
            number: [],
        }
    },
    watch: {
        'form.user_id.val': {
            handler(){
                if(this.form.users.val != ''){
                    this.get_numbers();
                }
            }
        }
    },
    mounted(){
        this.get_users();
        this.get_number_custom_blacklist();
    },
    methods: {
        submit(){
            if(this.disable == false){
                const data = new FormData();
                for (const key in this.form){
                    data.set(key, this.form[key].val);
                }
                data.set('ids', JSON.stringify([parseInt(this.$route.params.id)]));
                this.axios.put('custom_black_lists/', data)
                    .then(() => {
                        this.$notify({
                            group: 'foo',
                            type: 'success',
                            text: 'ویرایش با موفقیت انجام شد.'
                        });
                        for (const key in this.form){
                            this.form[key].val = '';
                        }
                    })
                    .catch(() => {
                        this.$notify({
                            group: 'foo',
                            type: 'error',
                            text: 'خطا! لطفا مجددا تلاش کنید.'
                        });
                    })
            }
        },
        get_users(){
            this.axios.get('users/?type=view_user_nums')
                .then(res => {
                    res.data.map(val => {
                        this.users.push({value: val.id, text: `${val.id} - ${val.name}`})
                    });
                })
        },
        get_numbers(){
            this.numbers = [];
            this.axios.get('user_nums/'
                + '?user_id=' + this.form.user_id.val)
                .then(res => {
                    res.data.map(val => {
                        this.numbers.push({value: val.id, text: `${val.name}`});
                    });
                })
        },
        get_number_custom_blacklist(){
            this.axios.get('custom_black_lists/'
                + '?id=' + this.$route.params.id)
                .then(res => {
                    for(const key in res.data[0]){
                        for(const k in this.form){
                            if(key == k){
                                this.form[k].val = res.data[0][key];
                            }
                        }
                    }
                })
        }
    },
	beforeCreate(){
        if(this.$store.state.perms.can_update_custom_black_lists == false
            && this.$store.state.verif == false){
			this.$router.push('/403')
		}
	},
}
</script>
